import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import ConfirmPopup from './ConfirmPopup';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface DriverJobsPhotosProps {
    jobId: number;
    showModal: boolean;
    hideModal(): void;
}

interface AppFile {
    id: number;
    fileName: string;
    fileType: string;
    content: any;
}

const DriverJobsPhotosModal = (props: DriverJobsPhotosProps) => {
    const [loading, setLoading] = React.useState(true);
    const [uploadedFiles, setUploadedFiles] = React.useState<AppFile[]>([]);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);
    const [showConfirmModal, setShowConfirm] = React.useState(false);
    const [modalSaveDisabled, setModalSaveDisabled] = React.useState(false);

    React.useEffect(() => {
        getData(props.jobId);
    }, [props.jobId]);

    const getData = async (jobId: number) => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetDriverJobPhotos?JobId=' + jobId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setUploadedFiles(res.data);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const hideModal = () => {
        props.hideModal();
    }

    const handleImportFile = (e: any) => {
        setLoading(true);
        importPhotos(e.target.files);
    }

    const importPhotos = async (files: File[]) => {
        //save photos
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        const data = new FormData()
        data.append('jobId', props.jobId.toString());
        data.append('subId', user.sub);

        for (var i = 0; i < files.length; i++) {
            data.append('photos', files[i]);
        }

        //save photos
        axios.post('api/Job/ImportJobPhoto', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //save the returned photos
            var uploadedFileList = [...uploadedFiles];
            var photos = res.data;
                
            for (var p = 0; p < photos.length; p++) {
                var photo = photos[p];
                uploadedFileList.push(photo);
            }
            setUploadedFiles(uploadedFileList);
            setLoading(false);
            toast.success("Photos have been uploaded");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //DELETE
    const deletePhoto = (e: any, itemIndex: number) => {
        e.preventDefault();
        setDeleteIndex(itemIndex);
        setShowConfirm(true);
        setModalSaveDisabled(false);
    }

    const hideConfirmModal = () => {
        setDeleteIndex(-1);
        setShowConfirm(false);
        setModalSaveDisabled(false);
    }

    const saveConfirmModal = () => {
        if (modalSaveDisabled) {
            return;
        }

        deleteJobPhoto();
    }

    const deleteJobPhoto = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var photos = [...uploadedFiles];
        var photo = photos[deleteIndex];

        var data = {
            id: photo.id,
            subId: user.sub
        };

        //delete photo
        axios.post('api/Job/DeleteDriverJobPhoto', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                photos.splice(deleteIndex, 1);
                setUploadedFiles(photos);
                setDeleteIndex(-1);
                setShowConfirm(false);
                setModalSaveDisabled(true);
                toast.success("Photo has been deleted");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });

    }
    //END DELETE


    const confirmPopup = <ConfirmPopup heading="Delete Photo?" text="Are you sure you want to delete this photo?" hideConfirmModal={hideConfirmModal} showConfirmModal={showConfirmModal} saveConfirmModal={saveConfirmModal} />

    return (
        <div>
            <div className="static-modal">
                {confirmPopup}
            </div>
            <Modal size="lg" show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Upload Photo/s</Modal.Title>
                    <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div className={loading ? "hidden" : "marginTop10"}>
                        <input type="file" className="marginBottom10" name="file" accept="image/*" onChange={handleImportFile} multiple />
                    </div>
                    <div className={uploadedFiles.length === 0 || loading ? "hidden" : ""}>
                        <hr></hr>
                        {uploadedFiles.map((uploadedFile, index) =>
                            <div key={index} className="input-group-parent marginBottom10" >
                                <div className="photoImport__deleteParent--position">
                                    <a className="makeitred photoImport__delete--position" href="#" onClick={(e) => deletePhoto(e, index)}>
                                        <span className="fas fas fa-times-circle mobileMenuSize alignIconCenter"></span>
                                    </a>
                                    <img className="mobile-width" src={uploadedFile.id > 0 ? "data:" + uploadedFile.fileType + ";base64," + uploadedFile.content : uploadedFile.content}></img>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className={loading ? "marginTop10" : "hidden"}>
                        <span>Loading Photos...</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={hideModal} disabled={loading}>Close</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DriverJobsPhotosModal;